"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["platform", "type", "base", "user", "repo", "tag", "path", "total"];
var Downloads = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'github' : _props$platform,
    _props$type = props.type,
    type = _props$type === void 0 ? 'downloads' : _props$type,
    _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    user = props.user,
    repo = props.repo,
    tag = props.tag,
    path = props.path,
    _props$total = props.total,
    total = _props$total === void 0 ? true : _props$total,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    if (platform !== 'github' || !/^(downloads|downloads-pre)/.test(type || '')) return '';
    var baseData = [base, platform, type, user, repo];
    if (path && tag) {
      return [].concat(baseData, [tag, path]).join('/');
    }
    if (total && tag || type === 'downloads-pre' && tag && total) {
      return [].concat(baseData, [tag, 'total']).join('/');
    }
    if (total) {
      return [].concat(baseData, ['total']).join('/');
    }
    return '';
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Downloads.displayName = 'Downloads';
var _default = exports["default"] = Downloads;
module.exports = exports.default;